export default {
  downtimeUrl: "https://www.kodland.org/tr",
  showAgeRules: true,
  parameters: {
    landing_id: "TrQMine",
    segment: 11,
    success_page: 'turkey_teens',
  },
  startPage: {
    image: "/welcome/turkey_mine_desk.png",
    imageMobile: "/welcome/turkey_mine_mob.png",
    title: "Ücretsiz Minecraft dersinizi almak ve 5.000 TL indirim fırsatını kaçırmamak için kısa soruları yanıtlayın!",
    subtitle: "🎮 Minecraft ile öğrenmeye hazır mısınız? AcaVIP ve CGV Çocuk Aile Kulübü üyelerine özel bu fırsatla, ücretsiz bir dersin tadını çıkarın ve tüm eğitimlerde geçerli 5.000 TL indirim avantajından yararlanın!",
    button: "🕒 Kayıt 2 dakika",
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title:
      "Eğitim platformumuza güvendiğiniz için teşekkür ederiz! Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
  },
  quizRotateBySteps: {
    1: {
      question: "Çocuğunuzun okulda en sevdiği ders nedir?",
      answers: [
        "🎨 Sanat ve tasarım",
        "💻 Bilgisayar bilimi",
        "📙 Tarih, Edebiyat",
        "📐 Matematik",
        "💬 Yabancı diller",
        "🤔 Emin değilim",
      ],
    },
    2: {
      question: "Çalışabileceğiniz bir masaüstü/dizüstü bilgisayarınız var mı?",
      answers: [
        {
          answer: "💻 Evet",
          distribution_tag_question: [18],
        },
        {
          answer: "😐 Hayır",
          stopAnswer: true,
        },
      ],
    },
    3: {
      question: "Çocuğunuzun bilgisayar becerileri var mı?",
      answers: [
        "😌 Evet, Microsoft Word/PowerPoint",
        "🖥 Evet, temel kodlama",
        "👍 Evet, kendisi bir oyun meraklısı (Minecraft, Roblox)",
        "🤔 Hayır",
      ],
    },
    4: {
      title: "Yolu yarıladık! Çocuğunuzun yaşını seçin, böylece ona göre bir sınıf oluşturabiliriz",
      type: "age",
      button: "İleri 🚀",
    },
    5: {
      title: "Ücretsiz çevrimiçi ders için ne zaman müsaitsiniz?",
      type: "timeslot",
      subtitle:
        "Yerinizi ayırtmak için sadece birkaç adım kaldı! Sizinle tanışmak için sabırsızlanıyoruz🥳",
      button: "Rezervasyon için tıklayın 🎁",
    },
    6: {
      title: "Ebeveyn Adı",
      type: "parent_name",
      subtitle: "Biz Kodland, peki ya sen kimsin 👀",
      button: "İleri 🚀",
    },
    7: {
      title: "Telefon numaranızı girin",
      type: "phone",
      subtitle:
        "Sizi sınıfın WhatsApp sohbetine ekleyeceğiz 💬",
      button: "İleri 🚀",
    },
    8: {
      title: "Çocuğunuzun adı nedir?",
      type: "child_name",
      subtitle: "Derse kaydolmanız için buna ihtiyacımız var ✅",
      button: "Neredeyse bitti 🔥",
    },
    9: {
      title: "E-postanızı girin",
      type: "mail",
      subtitle: "Derse kaydolmanız için buna da ihtiyacımız var 👌",
      button: "Son adım! 🎉",
    },
  },
};
